
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";
import MSG from '../../Checkout/checkout.messages';

const MESSAGES = defineMessages({
  elementsPositionsLeft: {
    id: "ElementsPositionsLeft.left",
    defaultMessage: "left",
  },
  elementsPositionsRight: {
    id: "ElementsPositionsRight.right",
    defaultMessage: "right",
  },
  warningElementPosition: {
    id: "ElementsPositionsRight.warning", 
    defaultMessage: "Disabled, please increase distance between troughs.",
  },
  right: MSG.checkoutRight,
  left: MSG.checkoutLeft,
});

export default MESSAGES;